// import { CacheDataRequest } from "./setting";
import { SortItem, IFilter } from "./filtrable";



export interface IPage {
  pageNumber?: number;
  pageSize?: number;
  skipPagesCalculation?: boolean;
}

export interface IRequestParameter {
  page: IPage;
  filters?: IFilter[];
  sorts?: SortItem[];
  data?: { [s: string]: any };
}

export class RequestParameter implements IRequestParameter {
  constructor(page?: IPage) {
    this.page = page;
  }
  page: IPage;
  filters? = new Array<IFilter>();
  sorts? = new Array<SortItem>();
  data?: { [s: string]: any } = { firstLoad: true };
}


// export class SecurityParam {
//   crud: number;
//   enableAuthAction: boolean;
// }


// export class ResponseSetting {
//   filterStorage = new Array<IFilter>();
//   cacheData: any;
//   securityParam = new SecurityParam();

//   defaultModel: any = {};
// }

// export interface IDslResponse {
//   dataSource?: any;
//   rowCount?: number;
//   // setting: ResponseSetting;
//   filters: IFilter[];
//   lookupList: { [prop: string]: any[] };
//   updateExtras: boolean;
// }



// export class VirtualScrollPage {
//   //  rowCount?: number;
//   pageNumber: number;
//   pageSize: number;
//   skipPagesCalculation = true;
// }

